import { useState, useEffect } from 'react';
import { useLocale } from '../context/LocaleContext';
import { translateText, translateObject, needsTranslation } from '../services/translationService';
import { isPrerendering } from '../utils/prerender';

export function useTranslateText(text) {
  const { localeKey } = useLocale();
  const [result, setResult] = useState(text);

  useEffect(() => {
    let cancelled = false;
    // Le HTML statique doit rester sur le texte source (non traduit) — c'est l'état
    // initial exact que le client reproduit avant ses propres effets.
    if (isPrerendering() || !needsTranslation(localeKey)) {
      setResult(text);
      return;
    }
    translateText(text, localeKey).then(r => { if (!cancelled) setResult(r); });
    return () => { cancelled = true; };
  }, [text, localeKey]);

  return result;
}

export function useTranslateObject(obj) {
  const { localeKey } = useLocale();
  const serialized = JSON.stringify(obj);
  const [result, setResult] = useState(obj);

  useEffect(() => {
    let cancelled = false;
    if (isPrerendering() || !needsTranslation(localeKey)) {
      setResult(obj);
      return;
    }
    translateObject(obj, localeKey)
      .then(r => { if (!cancelled) setResult(r); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [serialized, localeKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return result;
}
